import React from 'react';
import evaluation_png from '../../../assets/images/illustrations/03_services_fullEvaluation.png';
import evaluation from '../../../assets/images/Autism-webp/05/03_05@3x.webp';
import id_png from '../../../assets/images/illustrations/03_services_IDCard.png';
import id from '../../../assets/images/Autism-webp/02/03_02@3x.webp';
import individual_png from '../../../assets/images/illustrations/03_services_individualTreatment.png';
import individual from '../../../assets/images/Autism-webp/03/03_03@3x.webp';
import rehab_png from '../../../assets/images/illustrations/03_services_rehabilitationIntervention.png';
import rehab from '../../../assets/images/Autism-webp/01/03_01@3x.webp';
import training_png from '../../../assets/images/illustrations/03_services_trainingPrograms.png';
import training from '../../../assets/images/Autism-webp/04/03_04@3x.webp';
import { api_url, headers } from '../../../common/config';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

const Service = ({ image, fallback_image, title, body }) => {
    return (
        <>
            <div className='accordion-head'>
                <div className='img-container'>
                    <div
                        className={`img-circle ${
                            i18next.language === 'en' ? 'en-img-circle' : ''
                        }`}
                    >
                        <picture>
                            <source srcSet={fallback_image} type='image/png' />
                            <source srcSet={image} type='image/webp' />
                            <img
                                src={image}
                                alt='service'
                                className='service-img'
                            />
                        </picture>
                    </div>
                </div>
                <h1
                    className={`${
                        i18next.language === 'en' ? 'text-left' : ''
                    }`}
                >
                    {title}
                </h1>
            </div>
            <div className='accordion-item-content'>
                <h6
                    className={`${
                        i18next.language === 'en' ? 'en-body pl-4' : ''
                    }`}
                >
                    {body}
                </h6>
            </div>
        </>
    );
};

function ServicesCards() {
    const { t } = useTranslation();
    return (
        <div
            className={`accordion-container ${
                i18next.language === 'en' ? 'en-accordion-container' : ''
            }`}
        >
            <div className='accordion'>
                <div className='accordion-item accordion-item--default'>
                    <Service
                        image={evaluation}
                        fallback_image={evaluation_png}
                        title={t('homepage.services.servicesList.eval.title')}
                        body={t('homepage.services.servicesList.eval.desc')}
                    />
                </div>
                <div className='accordion-item'>
                    <Service
                        image={rehab}
                        fallback_image={rehab_png}
                        title={t(
                            'homepage.services.servicesList.rehabProgram.title'
                        )}
                        body={t(
                            'homepage.services.servicesList.rehabProgram.desc'
                        )}
                    />
                </div>
                <div className='accordion-item'>
                    <Service
                        image={individual}
                        fallback_image={individual_png}
                        title={t(
                            'homepage.services.servicesList.treatment.title'
                        )}
                        body={t(
                            'homepage.services.servicesList.treatment.desc'
                        )}
                    />
                </div>
                <div className='accordion-item'>
                    <Service
                        image={training}
                        fallback_image={training_png}
                        title={t(
                            'homepage.services.servicesList.devTraining.title'
                        )}
                        body={t(
                            'homepage.services.servicesList.devTraining.desc'
                        )}
                    />
                </div>
                <div className='accordion-item'>
                    <Service
                        image={id}
                        fallback_image={id_png}
                        title={t(
                            'homepage.services.servicesList.vocTraining.title'
                        )}
                        body={t(
                            'homepage.services.servicesList.vocTraining.desc'
                        )}
                    />
                </div>
            </div>
        </div>
    );
}

export default ServicesCards;
